#import "./TrainingCategoryFields.graphql"

mutation UpdateTrainingCategory($id: ID!, $name: String, $archived: Boolean) {
  updateTrainingCategory(input: { id: $id, name: $name, archived: $archived }) {
    trainingCategory {
      ...TrainingCategoryFields
    }
  }
}
